<template>
  <div class="dialog-overlay" @click.stop>
    <Transition mode="out-in" name="fade">
      <div v-if="step == 1" class="step-1">
        <i-local-close class="close-btn" @click.stop="emits('close')" />
        <div>How was your experience?</div>
        <div class="thumbs">
          <a v-ga-event="{ interaction: 'thumbs-up' }" title="good" @click="setThumb('up')"
            ><i-ic-outline-thumb-up
          /></a>
          <a v-ga-event="{ interaction: 'thumbs-down' }" title="bad" @click="setThumb('down')"
            ><i-ic-outline-thumb-down
          /></a>
        </div>
        <div class="skip-and-close" @click="emits('close')">Skip and Close</div>
      </div>
      <div v-else-if="step == 2" class="step-2">
        <i-local-close class="close-btn" @click.stop="emits('close')" />
        <div class="header">How was your experience?</div>
        <AutoResizedTextarea
          v-model="feedback"
          class="body"
          maxlength="300"
          placeholder="(Optional) Provide any additional feedback (0/300)"
        />
        <div class="bottom">
          <ChatbotButton v-ga-event="{ interaction: 'submit-survey' }" @click="submit">SUBMIT</ChatbotButton>
        </div>
      </div>
      <div v-else-if="step == 3" class="step-3">
        <div>Thanks for your feedback!</div>
        <img src="~@/assets/imgs/chatbot/survey-end-icon.webp" />
      </div>
    </Transition>
  </div>
</template>
<script setup lang="ts">
  import { useChatbotSurveyStore } from '@/store/Chatbot/Survey'

  const step = ref(1)
  const feedback = ref('')

  const emits = defineEmits(['close'])

  function setThumb(val: string) {
    step.value = 2
    surveyStore.submitSurvey({ thumb: val })
  }

  const surveyStore = useChatbotSurveyStore()

  onMounted(() => {
    surveyStore.saveChatData()
  })

  function submit() {
    surveyStore.submitSurvey({ feedback: feedback.value })
    step.value = 3
    setTimeout(() => {
      emits('close')
    }, 2000)
  }
</script>

<style lang="scss" scoped>
  .bold {
    font-weight: 700;
  }
  .close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    width: 20px;
    height: 20px;
    padding: 4px;
  }
  .dialog-overlay {
    width: 320px;
    font-size: 15px;

    font-family: 'Roboto', sans-serif;
    font-weight: 700;
    font-style: normal;
    // transition: 0.3s;
    color: #546e7a;
    > div {
      width: 100%;
      background-color: #eceff1;
      border-radius: 15px;
      text-align: center;
      padding: 40px;
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      align-items: center;
      overflow: hidden;
      box-shadow: 0px 4px 5px -2px rgba(0, 0, 0, 0.3), 0px 7px 10px 1px rgba(0, 0, 0, 0.2),
        0px -7px 10px 1px rgba(0, 0, 0, 0.2), 0px 2px 16px 1px rgba(0, 0, 0, 0.16) !important;
    }
    .step-2 {
      display: block;
      padding: 0;
      .header,
      .bottom {
        padding: 20px 0;
      }
      .body {
        background-color: white;
        min-height: 200px;
        border-radius: 0;
        border-top: 2px solid #90a4ae;
        border-bottom: 2px solid #90a4ae;
        // overflow-y: auto;
      }
    }
  }
  .skip-and-close {
    margin-top: 20px;
    text-decoration: underline;
    cursor: pointer;
    &:hover {
      color: #bf360c;
    }
  }
  .thumbs {
    display: flex;
    column-gap: 30px;
    color: #90a4ae;
    svg {
      width: 34px;
      height: 34px;
      cursor: pointer;
      &:hover,
      &.selected {
        color: #bf360c;
      }
    }
    &.rated {
      pointer-events: none;
    }
  }
</style>
